import axios from "axios"
import { HeaderOptions, Proxy } from "../utils/headers"

export const GetAllDoctors = async () => {
     const data = await axios.get(`${process.env.REACT_APP_BACKEND_API}/api/doctor/getDoctors`, {

     })
     return data.data.data.doctors
}